import "./App.css";
import React from "react";
import Calculator from "./calc/calc.jsx";

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;
